/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAlertChartNotificationFromJSON, ApiAlertChartNotificationToJSON, } from './ApiAlertChartNotification';
import { ApiAlertIntervalTypeFromJSON, ApiAlertIntervalTypeToJSON, } from './ApiAlertIntervalType';
import { ApiAlertRequirementFromJSON, ApiAlertRequirementToJSON, } from './ApiAlertRequirement';
import { ApiAlertTypeFromJSON, ApiAlertTypeToJSON, } from './ApiAlertType';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiRecipientFromJSON, ApiRecipientToJSON, } from './ApiRecipient';
export function ApiAlertFromJSON(json) {
    return ApiAlertFromJSONTyped(json, false);
}
export function ApiAlertFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chartNotifications': !exists(json, 'chartNotifications') ? undefined : (json['chartNotifications'].map(ApiAlertChartNotificationFromJSON)),
        'checkedAt': !exists(json, 'checkedAt') ? undefined : (new Date(json['checkedAt'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'interval': !exists(json, 'interval') ? undefined : json['interval'],
        'intervalType': !exists(json, 'intervalType') ? undefined : ApiAlertIntervalTypeFromJSON(json['intervalType']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notifiedAt': !exists(json, 'notifiedAt') ? undefined : (new Date(json['notifiedAt'])),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'recipients': !exists(json, 'recipients') ? undefined : (json['recipients'].map(ApiRecipientFromJSON)),
        'requirements': !exists(json, 'requirements') ? undefined : (json['requirements'].map(ApiAlertRequirementFromJSON)),
        'type': !exists(json, 'type') ? undefined : ApiAlertTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiAlertToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chartNotifications': value.chartNotifications === undefined ? undefined : (value.chartNotifications.map(ApiAlertChartNotificationToJSON)),
        'checkedAt': value.checkedAt === undefined ? undefined : (value.checkedAt.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'description': value.description,
        'id': value.id,
        'interval': value.interval,
        'intervalType': ApiAlertIntervalTypeToJSON(value.intervalType),
        'name': value.name,
        'notifiedAt': value.notifiedAt === undefined ? undefined : (value.notifiedAt.toISOString()),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'recipients': value.recipients === undefined ? undefined : (value.recipients.map(ApiRecipientToJSON)),
        'requirements': value.requirements === undefined ? undefined : (value.requirements.map(ApiAlertRequirementToJSON)),
        'type': ApiAlertTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
